import backendService from './backendService';

const RESPONSE_TTL_MS = 8000;
/** Falhas recentes (rede/CORS/HTTP): evita repetir fetch ao montar o slot logo após o prefetch */
const FAILURE_CACHE_TTL_MS = RESPONSE_TTL_MS;
const responseCache = new Map();
const failureUntilByCarouselId = new Map();
const inflightByCarouselId = new Map();

/**
 * @param {{ carouselId: string, signal?: AbortSignal }} options
 * @returns {Promise<object|undefined>}
 */
export async function getCommunicationCarousel(options) {
  const { carouselId: rawId } = options || {};
  const carouselId = String(rawId || '').trim();

  if (!carouselId) {
    return undefined;
  }

  const now = Date.now();
  const failUntil = failureUntilByCarouselId.get(carouselId);
  if (failUntil) {
    if (failUntil <= now) {
      failureUntilByCarouselId.delete(carouselId);
    } else {
      return undefined;
    }
  }

  const cached = responseCache.get(carouselId);
  if (cached && cached.expiresAt > now) {
    return cached.body;
  }

  const pending = inflightByCarouselId.get(carouselId);
  if (pending) {
    return pending;
  }

  const promise = (async () => {
    try {
      const response = await backendService.layout.v4.getCarouselCommunication(carouselId);
      const json = response?.data;

      if (!json) {
        failureUntilByCarouselId.set(carouselId, Date.now() + FAILURE_CACHE_TTL_MS);
        return undefined;
      }

      failureUntilByCarouselId.delete(carouselId);
      responseCache.set(carouselId, {
        body: json,
        expiresAt: Date.now() + RESPONSE_TTL_MS,
      });
      return json;
    } catch (error) {
      failureUntilByCarouselId.set(carouselId, Date.now() + FAILURE_CACHE_TTL_MS);
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console -- log only in dev for integration debugging
        console.error('[communicationCarousel]', error);
      }
      return undefined;
    } finally {
      inflightByCarouselId.delete(carouselId);
    }
  })();

  inflightByCarouselId.set(carouselId, promise);
  return promise;
}
